
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Blog from './Pages/Blog/Blog';
import Contact from './Pages/Contact/Contact';
import Footer from './Pages/Footer/Footer';
import Home from './Pages/Home/Home';
import AppBer from './Share/AppBer';




function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(false)
    setTimeout(() => {
      setLoading(true)
    }, 1000)
  }, [])
  return (
    <>
      {
        loading ? (
          <div className="App">
            <Router>
            <AppBer />
              <Routes>
                <Route path='/' element={<Home />} ></Route>
                <Route path='/home' element={<Home />} ></Route>
                <Route path='/contact' element={<Contact />} ></Route>
                <Route path='/blog' element={<Blog />} ></Route>

              </Routes>
              <Footer />
            </Router>
          </div>
        ) : (
          <div id="preloader">
            <div class="outer">
              <div class="infinityChrome">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="infinity">
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="goo-outer">
                <defs>
                  <filter id="goo">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="6" result="blur" />
                    <feColorMatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
                    <feBlend in="SourceGraphic" in2="goo" />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        )
      }
    </>
  );
}

export default App;
